<div class="container">
  <div class="heading_align">
    <div class="heading">Geschäftsbedingungen für die Nutzung <span class="font_14 font_normal"> - für Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (showSCPToU) {
      <div mat-dialog-content>
        <!-- First div -->
        <div class="eula_points"><b>GÜLTIG: 11.Juli 2023</b></div>
        <div class="eula_points">
          Die folgenden Synappx™-Nutzungsbedingungen sowie die hierin durch Verweis aufgenommene <a tabindex="-1"
          class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx-Datenschutzrichtlinie</b></a>
          (zusammen die „Vereinbarung“) gilt zwischen der Sharp Corporation („Sharp“) und dem Kunden. Diese
          Vereinbarung regelt den Zugriff auf und die Nutzung von Synappx sowie alle Services, die über Synappx
          zugänglich sind. Für die Zwecke dieser Vereinbarung bezeichnet der Begriff „Synappx“ Folgendes: Synappx Go, Synappx Cloud Print, Synappx Admin Portal und die zugehörige Dokumentation; der Begriff „Services“ bezeichnet:
          Synappx Services, Spezifische Software-Services und die gesamte zugehörige Dokumentation, welche das
          Eigentum von Sharp und/oder Drittanbietern von Services („Drittanbieter“) sein können und auf die über den
          Synappx Service zugegriffen werden kann.
        </div>
      </div>
    }
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <!-- Second div -->
        <div class="eula_points"><b>GÜLTIG: 25/04/2023</b></div>
        <div class="eula_points">
          Die folgenden Synappx™-Nutzungsbedingungen sowie die hierin durch Verweis aufgenommene <a tabindex="-1"
          class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx-Datenschutzrichtlinie</b></a>
          (zusammen die „Vereinbarung“) gilt zwischen der Sharp Corporation („Sharp“) und dem Kunden. Diese
          Vereinbarung regelt den Zugriff auf und die Nutzung von Synappx sowie alle Services, die über Synappx
          zugänglich sind. Für die Zwecke dieser Vereinbarung bezeichnet der Begriff „Synappx“ Folgendes: Synappx Go,
          Synappx Admin Portal und die zugehörige Dokumentation; der Begriff „Services“ bezeichnet:
          Synappx Services, Spezifische Software-Services und die gesamte zugehörige Dokumentation, welche das
          Eigentum von Sharp und/oder Drittanbietern von Services („Drittanbieter“) sein können und auf die über den
          Synappx Service zugegriffen werden kann.
        </div>
      </div>
    }
    <div class="eula_points">
      Die Nutzung der Services ist für Organisationen („Kunde“) und ihre Endbenutzer bestimmt. Der Begriff
      „Endbenutzer“ (in Singular und Plural) und seine Variationen sollen jeden Zugriffsservice umfassen, der von
      Synappx Service bereitgestellt wird und kann Folgendes umfassen, ist aber nicht darauf beschränkt:
      Angestellte, Vertreter, Vertragsnehmer, Agenten oder jede andere Person, wer auch immer die Services über
      ein Kundenkonto nutzt oder darüber darauf zugreift und vom Kunden autorisiert wurde, die Services zu nutzen.
      Alle Referenzen auf den Begriff „Kunde“ sollen sich auf Kunden und Kundinnen sowie auch auf den
      autorisierten Administrator/die autorisierten Administratoren des Kunden und alle seine Endbenutzer
      beziehen, egal ob individuell oder gemeinsam.
    </div>
    <div class="eula_points">
      Vor jeder Nutzung und ehe dem Kunden Zugriff gewährt wird, muss der autorisierte Administrator/müssen die
      autorisierten Administratoren für den Kunden dieser Vereinbarung im Namen des Kunden zustimmen. Indem Sie
      auf „Agree“ (Zustimmen) klicken, erklären und garantieren Sie, der Administrator, dass: 1) Sie vom Kunden
      als „Administrator“ bestimmt wurden und dass Sie anspruchsberechtigt auf alle Rechte und Privilegien sind,
      die jenen Personen in der Rolle eines Administrators gewährt werden (ausführlicher weiter unten
      beschrieben); 2) Sie die Befugnis besitzen, den Kunden an diesen Vertrag zu binden. Wenn Sie nicht als
      Administrator für den Kunden eingesetzt wurden oder nicht über die oben dargelegten Befugnisse verfügen,
      dürfen Sie nicht auf „Agree“ (Zustimmen) klicken und der Kunde darf die Services nicht nutzen und nicht
      darauf zugreifen. Wenn Sie auf „Agree“ (Zustimmen) klicken, soll der Kunde das Recht besitzen, die Services
      entsprechend den hier dargelegten Bestimmungen zu nutzen und auf sie zuzugreifen.
    </div>
    <div class="eula_points">
      Es gibt womöglich weitere spezifische Software-Services („Spezifische Software-Services“) innerhalb der
      Synappx Admin Services oder auf die durch die Synappx Admin Services zugegriffen werden kann, die es dem
      Kunden gestatten, bestimmte Funktionen ausführen oder zusätzliche Services und Funktionen zu nutzen; diese
      Spezifischen Software-Services sind das Eigentum von Sharp und/oder Drittanbietern von Services. Der Kunde
      versteht, dass die Nutzung und/oder der Zugriff auf diese Spezifischen Software-Services erfordern kann,
      dass Kunde, Administrator(en) und/oder entsprechende Endbenutzer zusätzlichen Geschäftsbedingungen
      zustimmen, die für die Nutzung der und/oder den Zugriff auf die Spezifischen Software-Services gelten
      („Zusätzliche Bestimmungen“). Wenn Kunde, Administrator(en) und/oder Endbenutzer derartigen Bestimmungen
      nicht zustimmen oder nicht die Autorität besitzen, derartigen Zusätzlichen Bestimmungen zuzustimmen, dürfen
      Kunde, Administrator(en) und/oder entsprechende Endbenutzer die Spezifischen Software-Services nicht nutzen
      und nicht darauf zugreifen, wie zutreffend. Falls sich diese Vereinbarung und die Zusätzlichen Bestimmungen
      widersprechen, gelten die Zusatzbedingungen, jedoch nur für diesen speziellen Software-Service.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definitionen</b> <br />
        Zusätzlich zu allen oben dargelegten definierten Begriffen gelten für diese Vereinbarung folgende
        Definitionen:
        <ol>
          <li> <b>Kundenkonto:</b> Bezieht sich auf alle Konten, die einem Kunden
          untergeordnet oder zugeordnet sind. Dazu gehören alle zutreffenden Administratorkonten sowie
          alle Services, die dem Kunden, dem Administrator/den Administratoren und/oder den entsprechenden
          Endbenutzern lizenziert wurden und die Informationen, die dem Kunden, dem Administrator/den
        Administratoren und/oder den entsprechenden Endbenutzern zugeordnet sind.</li>
        <li> <b>Administrator:</b> Der/die Mitarbeiter, der/die vom Kunden
        eingesetzt wurde/wurden, um die Informationen und Daten zu verwalten, die mit dem Kundenkonto in
      Verbindung stehen, sowie der Zugriff auf und die Lizenzen für Services im Namen des Kunden.</li>
      <li> <b>Administratorkonto:</b> Dies bezieht sich auf das Konto des
    Administrators.:</li>
    <li> <b>Kundendaten:</b> Alle Daten, von Kunden, Administrator(en) und/oder
    den entsprechenden Endbenutzern über die Services gespeicherte, übertragene, verarbeitete oder
    abgerufene Informationen oder Informationen, die mit einem Kundenkonto in Verbindung stehen.
  </li>
  <li> <b>Händler:</b> Der autorisierte Wiederverkäufer, der die Services an
  den Kunden verkauft; beim Händler kann es sich um Sharp, seine Niederlassungen oder die direkten
  Händlerfilialen der Niederlassungen (bei Direktverkäufen an einen Kunden) oder einen
  autorisierten Dritt-Wiederverkäufer von Produkten und Services von Sharp handeln. Der Händler
  ist für den Kunden außerdem der Hauptansprechpartner bei Support-Fragen bezüglich der
  Services. Der Händler kann dem Kunden Dienstleistungen gemäß einem Vertrag mit dem Kunden
und/oder Administrator bereitstellen.</li>
<li> <b>Dokumentation:</b> Alle Installationsanleitungen und
Benutzerhandbücher, Hilfedateien, FAQs bezüglich des Zugriffs auf oder hinsichtlich der Nutzung
der Services.</li>
<li> <b>Geistige Eigentumsrechte:</b> Alle aktuellen oder zukünftigen
weltweiten Rechte an Patenten, Urheberrechten, Geschäftsgeheimnissen, Warenzeichen, moralischen
Rechten und anderen geistigen Eigentumsrechten.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Nutzung und Verantwortlichkeiten des Kunden </b>
  <ol>
    <li> Der Kunde trägt die Verantwortung für die Bestimmung, welche Person(en) autorisiert ist/sind
      und die Rolle des Administrators im Namen des Kunden übernimmt/übernehmen. Der Kunde kann
    Administratorkonten zuweisen und neu zuweisen.</li>
    <li> Der Kunde ist für Folgendes verantwortlich: die Verwaltung des Zugriffs auf Administratorkonten
      und die Sicherstellung, dass der Zugriff von Kunde, Administrator(en) und Endbenutzer auf die
      Services und/oder die Nutzung der Services durch Kunde, Administrator(en) und Endbenutzer dieser
      Vereinbarung, den Zusätzlichen Bestimmungen und jeder anwendbaren Dokumentation
      entspricht/entsprechen. Sharp und die Händler sind nicht für die interne Verwaltung, die
    Administration oder die Nutzung der Services im Namen des Kunden verantwortlich.</li>
    <li> Der Kunde versteht und stimmt zu, dass sein(e) Administrator(en) und Endbenutzer dieser
      Vereinbarung, den Zusätzlichen Bestimmungen, der Dokumentation sowie allen anwendbaren Gesetzen,
      Regeln und Vorschriften hinsichtlich der Nutzung der Services unterliegen und diese einhalten
      werden. Der Kunde ist alleinig für alle Handlungen oder Unterlassungen des Kunden, seines
      Administrators/seiner Administratoren und der Endbenutzer oder ihrer Nichteinhaltung der
      Bestimmungen dieses Vertrags, der Zusätzlichen Bestimmungen, der Dokumentation oder der
      anwendbaren Gesetze, Regeln und Vorschriften hinsichtlich der Nutzung der Services
      verantwortlich. Diese Verantwortung gilt auch für alle Aktivitäten bezüglich eines Kundenkontos,
      egal ob die Aktivitäten vom Kunden, seinen Mitarbeitern oder einem Dritten (einschließlich, aber
      nicht beschränkt auf Vertragsnehmer, Vertreter oder Agenten des Kunden) durchgeführt werden.
    </li>
    <li> Der Kunde trägt die Verantwortung für die Sicherstellung, dass der/die Administrator(en) und
      die Endbenutzer sämtliche anwendbaren arbeitsvertraglichen Verpflichtungen und Bestimmungen und
      Richtlinien des Kunden einhalten, die als solche für den Zugriff auf die Services und die
    Nutzung der Services gelten.</li>
    <li> Damit sich die Administratoren an allen in dieser Vereinbarung beschriebenen Aktivitäten
      beteiligen können und damit Sharp und/oder Drittanbieter von Services die entsprechendem
      Services bereitstellen können, erklärt sich der Kunde damit einverstanden, alle anwendbaren
    Zustimmungen von Endbenutzern einzuholen und aufrechtzuerhalten.</li>
    <li> Der Kunde ist verantwortlich, falls Kunde, Administrator(en) und Endbenutzer unbefugt auf die
      Services zugreifen und/oder die Services unbefugt nutzen und der Kunde muss einen derartigen
      unbefugten Zugriff auf die Services und eine derartige unbefugte Nutzung der Services durch
      Kunde, Administrator(en) und Endbenutzer verhindern. Der Kunde wird Sharp und den Händler
      unverzüglich darüber informieren, falls ein unbefugter Zugriff und/oder eine unbefugte Nutzung
      der Services vorliegt. Sharp und der Händler sind für die unbefugte Nutzung von Kundenkonten
    oder den unbefugten Zugriff auf Kundenkonten nicht verantwortlich.</li>
    <li> Der Kunde wird die Services nur für seine eigenen internen Geschäftsvorgänge nutzen, aber nicht
      für den Betrieb eines Dienstleistungsunternehmens oder eines Timesharing-Dienstes. Der Kunde
      darf die Services nicht vorsätzlich oder absichtlich auf eine Weise nutzen oder eine derartige
      vorsätzliche oder absichtliche Nutzung der Services zulassen, wenn eine derartige Nutzung die
      Bereitstellung der Services beeinträchtigen, deaktivieren, überlasten, schädigen oder
      anderweitig stören könnte; dies umfasst, beschränkt sich aber nicht auf die Nutzung der Services
      zur Übertragung von Viren oder defekten Dateien, welche die Integrität und Sicherheit der
    Services in irgendeiner Form beeinträchtigen könnten.</li>
    <li> Der Kunde wird Folgendes weder direkt noch indirekt tun und der Kunde wird sicherstellen, dass
      sein(e) Administrator(en) oder Endbenutzer Folgendes weder direkt noch indirekt tun: (a)
      Zurückentwickeln, Dekompilieren, Disassemblieren des Quellcodes, des Objektcodes oder der
      zugrunde liegenden Struktur, der Ideen oder Algorithmen der Services oder beliebiger Software,
      der Dokumentation oder der Daten, die mit den Services im Zusammenhang stehen oder zusammen mit
      oder durch die Services bereitgestellt werden, oder anderweitige Versuche, diese zu analysieren;
      (b) Modifikation, Übersetzung oder Erstellung abgeleiteter Werke, die auf den Services basieren;
      oder Kopieren (außer für Archivierungszwecke), Vermieten, Verleasen, Verteilen, Verkaufen,
      Wiederverkaufen, Verpfänden, Abtreten oder eine anderweitige Übertragung oder Belastung der
      Rechte an den Services oder auf die Services; (c) Nutzung oder Zugriff auf die Services, um
      Produkte oder Services zu erstellen oder zu unterstützen, die mit den Services in Konkurrenz
      treten, und/oder Unterstützen einer Drittpartei bei der Nutzung oder dem Zugriff auf die
      Services, um Produkte oder Services zu erstellen oder zu unterstützen, die mit den Services in
      Konkurrenz treten; oder (d) Entfernen oder Ändern von Eigentumshinweisen oder Etiketten von den
    Services.</li>
    <li> Außerdem wird Kunde Folgendes nicht tun und der Kunde wird sicherstellen, dass sein(e)
      Administrator(en) oder Endbenutzer Folgendes nicht tun: (a) Nutzung der Services für
      Aktivitäten, bei denen die Nutzung oder der Ausfall der Services zu körperlichen Schäden,
      Personenschäden oder zum Tod führen könnte; (b) Nutzung der Services oder das Erlauben der
      Nutzung der Services für illegale, betrügerische, beleidigende oder schädliche Aktivitäten; (c)
      Nutzung der Services auf eine Weise, welche die Bereitstellung der Services beeinträchtigen,
      deaktivieren, überlasten, schädigen oder anderweitig stören könnte, einschließlich durch das
      Versenden von Viren oder defekten Dateien; oder (d) Nutzung der Services zur Verletzung oder zum
    Missbrauch geistiger Eigentumsrechte oder der Eigentumsrechte anderer.</li>
    <li> Der Kunde versteht, dass der Kunde dafür verantwortlich ist, alle anwendbaren vertikalen oder
      branchenspezifischen Vorschriften einzuhalten, und dass Sharp, Händler und/oder Drittanbieter
      von Services keinerlei Haftung übernehmen, wenn der Kunde dieser Vorschriften nicht einhält.
    </li>
    <li> Der Kunde ist alleinig dafür verantwortlich, geeignete Geräte und Zusatz-Services zu beschaffen
      und zu warten, die für den Anschluss an die Services, den Zugriff auf oder die Bereitstellung
      oder eine anderweitige Nutzung der Services benötigt werden, einschließlich, aber nicht
      beschränkt auf Computer, Computer-Betriebssystem(e) und Webbrowser, Internetzugang, mobile
      Geräte, Multifunktions-Peripheriegeräte („MFPs“), Display-Systeme, andere elektronische Geräte
      und anderes Zubehör (zusammenfassend bezeichnet als „Geräte“). Der Kunde muss gewährleisten,
      dass die Ausrüstung sämtlichen Konfigurationen und Spezifikationen entspricht, welche, sofern
      vorhanden, in der Dokumentation für die Services festgelegt sind. Über die Spezifischen
      Software-Services kann eine Dokumentation über die Spezifischen Software-Services zugänglich
    sein.</li>
    <li> Falls der Kunde bezüglich der Services, oder einem Teil davon, einen Abonnementvertrag mit
      einem Händler oder einem Drittanbieter von Services abgeschlossen hat, soll der Kunde
      gewährleisten, dass er einer derartigen Vereinbarung entspricht, inklusive der Zahlung aller
      anfallenden Gebühren, denn ein Versäumnis, dieser Verpflichtung nachzukommen, kann eine Sperrung
      oder Kündigung des Kundenkontos oder eine Sperrung des Zugriffs und der Nutzung der Services,
    oder eines Teils davon, zur Folge haben.</li>
    <li> Bei einer gültigen Zwangsvorladung, eines gültigen Gerichtsbeschlusses oder einer anderen
      gültigen Anfrage, die der Kunde im Zusammenhang mit den Services, einem Kundenkonto oder
      Kundendaten erhält, liegt es in der Verantwortung des Kunden, solche Anfragen über den Zugriff
      zu seinen eigenen Kundendaten zu beantworten. Wenn der Kunde nicht in der Lage sein sollte, auf
      die angeforderten Kundendaten oder andere angeforderte Informationen zuzugreifen, soll sich der
      Kunde mit Sharp in Verbindung setzen und Sharp soll alle wirtschaftlich angemessene
      Anstrengungen unternehmen, um den Kunden in dieser Angelegenheit zu unterstützen. Falls der
      Kunde nicht unverzüglich reagiert, kann Sharp auf eine derartige Anfrage eines Dritten
      antworten, ist aber nicht verpflichtet, darauf zu reagieren. Bei einer gültigen Zwangsvorladung,
      einem gültigen Gerichtsbeschlusses oder einer anderen gültigen Anfrage, die Sharp, Händler
      und/oder ein Drittanbieter von Services im Zusammenhang mit den Services, einem Kundenkonto oder
      Kundendaten erhält, einschließlich, aber nicht beschränkt auf Administratorkonten oder beliebige
      Daten innerhalb des Kundenkontos, müssen Sharp, Händler und/oder ein Drittanbieter von Services
      einer solchen Zwangsvorladung, einem solchen Gerichtsbeschlusses oder einer solchen Anfrage
      nachkommen, wie dies nach geltendem Recht erforderlich ist. Eine Beschreibung weiterer
      Informationen bezüglich der Nutzung der Kundenkonten oder des möglicherweise erforderlichen
      Zugriffs auf die Kundenkonten finden Sie in der <a tabindex="-1" class="text_underline"
      [href]="privacyUrl" target="_blank"><b>Synappx-Datenschutzrichtlinie</b></a>.</li>
      <li> Der Kunde ist verantwortlich für jede Verletzung dieses Abschnitts durch den Kunden,
        einschließlich seines Administrators/seiner Administratoren oder Endbenutzer. Der Kunde erkennt
        an und versteht, dass Sharp, Händler und Drittanbieter von Services keine Haftbarkeit gegenüber
        dem Kunden besitzen und auch anderweitig für keine vom Endbenutzer durchgeführten Handlungen
      haftbar sind.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>C. Administrator-Rolle</b>
    <ol>
      <li> Alle Administratoren müssen die Services in Übereinstimmung mit dieser Vereinbarung, den
        Zusätzlichen Bestimmungen, der Dokumentation, falls zutreffend, allen Verpflichtungen und
        Bestimmungen und Richtlinien des Kunden bezüglich der Beschäftigung sowie allen Gesetzen, Regeln
      und Vorschriften, die für den Zugriff auf und/oder die Nutzung der Services gelten, nutzen.</li>
      <li> Der Administrator versteht, dass der Kunde zusätzliche Administratorkonten zuweisen und neu
      zuweisen kann.</li>
      <li> Durch die Nutzung des Synappx-Administratorkontos behält ein Administrator die Kontrolle über
        das Kundenkonto durch die Verwaltung des Kundenkontos, einschließlich aller Lizenzen (einzeln
      oder gebündelt), die mit dem Kundenkonto verbunden sind.</li>
      <li> Der Administrator kann den Zugriff auf alle Kundenkonten, einschließlich zusätzlicher
        Administratorkonten, Workspace-Lizenzen oder Endbenutzer-Lizenzen einrichten, den Zugriff darauf
      gewähren, überwachen, beschränken, sperren und kündigen.</li>
      <li> Ein Administrator/Administratoren kann/können auch ein Endbenutzer sein – in diesem Fall gelten
        alle Bestimmungen in dieser Vereinbarung oder in den zusätzlichen Bestimmungen bezüglich eines
      Endbenutzers auch für den Administrator in seiner Funktion als Endbenutzer.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>D. Endbenutzer-Nutzung</b>
    <ol>
      <li> Der Kunde muss sicherstellen, dass Endbenutzer die Services in Übereinstimmung mit dieser
        Vereinbarung, den Zusätzlichen Bestimmungen, der Dokumentation, falls zutreffend, allen
        Verpflichtungen und Bestimmungen und Richtlinien des Kunden bezüglich der Beschäftigung sowie
        allen Gesetzen, Regeln und Vorschriften, die für den Zugriff auf und/oder die Nutzung der
      Services gelten, nutzen.</li>
      <li> Der Kunde ist für den Zugriff auf und die Nutzung der Services durch die Endbenutzer
      verantwortlich.</li>
      <li> Ein Endbenutzer darf seine Aktivität bei den Services nicht vom Kunden trennen.</li>
      <li> Der Kunde sichert Folgendes zu und gewährleistet: (a) Der Endbenutzer besitzt alle Rechte und
        Lizenzen, um auf die Services zuzugreifen und sie zu nutzen; und (b) Die Speicherung,
        Übertragung und Verarbeitung aller Informationen bezüglich des Endbenutzers sowie der Zugriff
        des Endbenutzers auf die Services verletzen keine Bestimmungen dieser Vereinbarung, der
        Zusätzlichen Bestimmungen, der maßgeblichen Dokumentation, die geistigen Eigentumsrechte oder
      der Eigentumsrechte anderer anwendbaren Gesetze, Regeln oder Richtlinien.</li>
      <li> Der Kunde bestätigt, dass er allein für die Beschaffenheit, Qualität und Genauigkeit aller
      Endbenutzer-Aktivitäten in Bezug auf die Services verantwortlich ist.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>E. Funktion des Händlers</b>
    <ol>
      <li> Der Händler ist dafür verantwortlich, dem Administrator/den Administratoren ein Kundenkonto
        einzurichten und die Lizenzen für Services bereitzustellen. Sobald ein Administrator für Kunden
      erstellt worden ist, kann der Händler keine Administratorkonten mehr erstellen.</li>
      <li> Händler können Lizenzen für Kundenkonten verwalten, dazu gehört auch der Kauf oder die
        Kündigung einer Lizenz. Ein Händler kann keine Lizenz kündigen, die dem Administrator schon
      bereitgestellt wurde, außer dies wird in dieser Vereinbarung ausdrücklich anders bestimmt.</li>
      <li> Händler können grundlegende Informationen zu Kundenkonten sowie auf den Namen, die Adresse und
        die Telefonnummern des Kunden sowie auf die Namen und E-Mail-Adressen aller Administratoren
        zugreifen. Händler haben außerdem Zugriff auf alle Kundenkonto-Lizenzen für Services und können
      diese aufrufen.</li>
      <li> Händler können den Zugriff eines Kunden auf das Kundenkonto sperren und/oder kündigen.</li>
      <li> Falls Ihr Händler ein Kundenkonto nicht mehr warten kann oder nicht mehr zur Wartung eines
        Kundenkontos berechtigt ist, können Sharp oder seine Partnerunternehmen das Kundenkonto
        nach alleinigem Ermessen auf einen anderen Händler übertragen. Ein Händler kann ein Kundenkonto
      nicht eigenständig auf einen anderen Händler übertragen.</li>
      <li>Der Händler kann die Services auf Anforderung des Kunden als Endbenutzer nutzen.</li>
    </ol>
  </div>
  <div class="eula_points"><b>F. Services</b>
  <ol>
    <li> Kunden dürfen nur im Einklang mit den Bestimmungen dieser Vereinbarung, den Zusätzlichen
      Bestimmungen, der Dokumentation und allen weiteren Bestimmungen bezüglich der Nutzung oder der
      anwendbaren Datenschutzrichtlinie auf die Services zugreifen und diese nutzen. Die
      Nichteinhaltung dieser Vereinbarung, der Zusätzlichen Bestimmungen, der Dokumentation und aller
      anwendbaren Gesetze, Regeln oder Richtlinien durch den Kunden kann dazu führen, dass ein
      derartiges Kundenkonto oder Administratorkonto nach dem alleinigem Ermessen von Sharp gesperrt
    oder gekündigt wird.</li>
    <li> Services oder Teile davon können Abonnementvereinbarungen mit Händlern und/oder Drittanbietern
      von Services unterliegen; die Nichteinhaltung derartiger Vereinbarungen durch den Kunden,
      einschließlich, aber nicht beschränkt auf die Zahlung aller entsprechenden Gebühren, kann als
      Folge dieser Nichteinhaltung zu einer Sperrung oder Kündigung des Kundenkontos oder des Zugriffs
    auf und der Nutzung der Services, oder eines Teils davon, führen.</li>
    <li> Der Zugriff auf und die Nutzung der Services ist außerdem davon abhängig, dass Sharp vom
      Händler alle Gebühren für den Zugriff auf die Services und für die Nutzung der Services durch
      den Kunden erhält; falls Sharp, oder seine Tochtergesellschaft, irgendwelche Gebühren bezüglich
      Ihres Kundenkontos nicht von Ihrem Händler erhält, und ein derartiges Versäumnis nicht innerhalb
      von dreißig (30) Tagen nach einer schriftlichen Mitteilung behoben wird, können Sharp, oder
      seine Tochtergesellschaft, nach alleinigem Ermessen, Ihr Kundenkonto sperren oder kündigen, bis
    Sharp, oder seine Tochtergesellschaft, derartige fällige Zahlungen erhält.</li>
    <li> Sharp wird wirtschaftlich erträgliche Mittel unternehmen, um zu garantieren, dass alle
      Einrichtungen, die für die Speicherung und Verarbeitung von Kundendaten genutzt werden,
      wirtschaftlich erträgliche Sicherheitsstandards erfüllen. Durch die Nutzung der Services stimmt
    der Kunde zu, dass Sharp die Kundendaten übertragen, verarbeiten und speichern darf.</li>
    <li> Der Kunde versteht, dass Sharp und/oder Drittanbieter von Services die Services gelegentlich
    mit oder ohne eine Benachrichtigung des Kunden aktualisieren können.</li>
    <li> Falls festgestellt wird, dass Kundendaten diese Vereinbarung verletzen oder verletzen könnten
      oder dass sie die Services in irgendeiner Weise beeinträchtigen, überlasten oder bedrohen oder
      Schäden an den Services verursachen könnten, können derartige Kundendaten ungeachtet anders
      lautender Bestimmungen vollständig oder teilweise, nach dem alleinigen Ermessen von Sharp, mit
      oder ohne eine Benachrichtigung des Kunden und ohne jegliche Haftung von Sharp, gelöscht werden.
      Der Kunde trägt die Verantwortung dafür, dass die Kundendaten im Falle einer derartigen Löschung
    gesichert werden.</li>
    <li> Zusätzliche Bestimmungen bezüglich des Datenschutzes, der Verarbeitung und der Speicherung der
      Kundendaten sowie des Zugriffs auf Kundenkonten werden in der <a tabindex="-1"
      class="text_underline" [href]="privacyUrl"
      target="_blank"><b>Synappx-Datenschutzrichtlinie</b></a> und der anwendbaren Dokumentation
    für die Services dargelegt.</li>
  </ol>
</div>
<div class="eula_points"><b>G. Support</b>
<ol>
  <li> Der Kunde trägt die Verantwortung dafür, dass er den Händler bei Support-Fragen hinsichtlich
    der Services kontaktiert, die nicht durch die Dokumentation für Spezifische Software-Services
  gelöst werden können.</li>
  <li> Außer wenn Sharp oder eine Sharp-Händlerniederlassung nicht der Händler für Ihr Kundenkonto
    ist, ist Sharp nicht dafür verantwortlich, dem Kunden irgendwelche Fragen bezüglich der oben
    genannten Services zu beantworten oder einen Support für die oben genannten Services
    bereitzustellen, welche/welcher darüber hinausgehen/hinausgeht, was durch die Dokumentation für
  Spezifische Software-Services bereitgestellt wird. </li>
</ol>
</div>
<div class="eula_points"><b>H. Geistiges Eigentum</b>
<ol>
  <li> Diese Vereinbarung gewährt Sharp, dem Händler oder einem Drittanbieter von Services keinerlei
    Rechte an Kundendaten oder den geistigen Eigentumsrechten, die in einem beliebigen Kundenkonto
    oder Administratorkonto enthalten sind, außer der beschränkten Rechte, die ausdrücklich in
    dieser Vereinbarung oder in Zusätzlichen Bestimmungen festgelegt sind oder die anderweitig zur
    Bereitstellung der Services benötigt werden und dem Kunden ermöglichen, die Services zu nutzen.
  </li>
  <li> Außer es wird in dieser Vereinbarung oder den Zusätzlichen Bestimmungen ausdrücklich anders
    festgelegt, wird dem Kunden, dem Administrator/den Administratoren oder den Endbenutzern keiner
    der folgenden Punkte gewährt: (a) irgendwelche geistigen Eigentumsrechte in den oder bezüglich
    der Services oder einem Teil davon; (b) irgendwelche geistigen Eigentumsrechte in anderen oder
    bezüglich anderer Kundenkonten; oder (c) irgendwelche Rechte zur Nutzung der Logos,
    Handelsmarken, Dienstleistungsmarken, Domain-Namen oder Branding-Features von Sharp, dem
    Händler, der Drittanbieter von Services, den Services oder irgendeiner Komponente der Services.
  </li>
  <li> Soweit Sharp vom Kunden, dem Administrator/den Administratoren oder einem Endbenutzer zu
    bestimmten Aktionen aufgefordert wird, einschließlich, aber nicht beschränkt auf das Übertragen,
    Hosten oder das gemeinsame Nutzen von Dateien, die Nutzung oder Gewährung des Zugriffs auf
    Funktionen oder Einstellungen des Produkts, dann erhält Sharp vom Kunden die Erlaubnis, alle
    erforderlichen Aktionen durchzuführen, die für Sharp oder den Händler erforderlich sind, um die
    Services und die Funktionalität bereitzustellen, die über die Services zur Verfügung stehen und
    die in der Dokumentation zusammengefasst werden können. Diese Erlaubnis erstreckt sich auf alle
  Services von Drittanbietern, die Sharp für die Bereitstellung der Services nutzt.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Ausschlussklauseln</b></div>
  <div class="eula_point_left">SHARP UNTERNIMMT WIRTSCHAFTLICH ANGEMESSENE ANSTRENGUNGEN, UM DIE SERVICES
    DEM KUNDEN ZUR NUTZUNG UND ZUM ZUGRIFF ZUR VERFÜGUNG ZU STELLEN, GEMÄSS DIESER VEREINBARUNG, DEN
    ZUSÄTZLICHEN BESTIMMUNGEN UND JEDER ANWENDBAREN DOKUMENTATION. UNGEACHTET ANDERS LAUTENDER
    BESTIMMUNGEN WERDEN DIE SERVICES „WIE GESEHEN“ ERBRACHT. IM VOLLEN GESETZLICH ZULÄSSIGEN UMFANG,
    SOFERN NICHT AUSDRÜCKLICH IN DIESER VEREINBARUNG FESTGELEGT, GIBT SHARP KEINERLEI GARANTIE FÜR SICH
    SELBST, HÄNDLER ODER DRITTANBIETER AB, GLEICH OB AUSDRÜCKLICH, IMPLIZIT ODER ANDERWEITIG,
    EINSCHLIESSLICH ALLER GARANTIEN, DASS DER SERVICE UNUNTERBROCHEN UND FEHLERFREI FUNKTIONIERT, DASS
    DER INHALT SICHER IST ODER NICHT ANDERWEITIG VERLOREN GEHT ODER BESCHÄDIGT WIRD, DASS FEHLER BEHOBEN
    WERDEN UND SHARP GIBT KEINERLEI GARANTIEN DER MARKTGÄNGIGKEIT, DER EIGNUNG FÜR EINEN BESTIMMTEN
    ZWECK ODER DER NICHTVERLETZUNG VON RECHTEN DRITTER AB. SHARP ÜBERNIMMT KEINE VERANTWORTUNG
    HINSICHTLICH IRGENDWELCHER INHALTE, UND DAZU GEHÖREN AUCH ALLE KUNDENDATEN IN ODER VON EINEM
    KUNDENKONTO, UND DER KUNDE SOLL ALLEINIG FÜR ALLE KUNDENDATEN SOWIE FÜR DEN ZUGRIFF AUF UND DIE
  NUTZUNG DER SERVICES VERANTWORTLICH SEIN.</div>
</div>

<div class="eula_points"><b>J. Laufzeit und Kündigung</b>
<ol>
  <li> Diese Vereinbarung bleibt in Kraft, bis der Kunde kein gültiges Abonnement oder keinen gültigen
    Zugriff mehr auf die Services hat, oder bis diese Vereinbarung gemäß den Bestimmungen gekündigt
    wird, die in dieser Vereinbarung festgelegt werden. Der Kunde versteht, dass bestimmte
    Spezifische Software-Services gemäß den Regelungen aller anwendbaren zusätzlichen Bestimmungen
  früher gekündigt werden können.</li>
  <li> Der Händler kann ein Kundenkonto kündigen, falls der Kunde für die Nutzung der Services keine
    Abonnementgebühren bezahlt, die an den Händler fällig sind, damit der Kunde die Services nutzen
  und auf sie zugreifen darf.</li>
  <li> Sharp kann diese Vereinbarung und Ihren Zugriff auf sowie Ihre Nutzung der Services kündigen,
    falls Sharp vom Händler für die Nutzung oder den Zugriff des Kunden auf die Services keine
    Gebühren erhält und ein derartiges Versäumnis nicht innerhalb von dreißig (30) Tagen nach
    schriftlicher Benachrichtigung behoben wird; eine solche Sperre oder Kündigung kann weiterhin
  gelten, bis Sharp die fälligen Zahlungen erhalten hat.</li>
  <li> Diese Vereinbarung und der Zugriff auf sowie die Nutzung der Services verlängern sich
    automatisch, außer der Kunde benachrichtigt den Händler darüber, dass er die Services kündigen
  möchte.</li>
  <li> Außerdem können Sharp oder ein Tochterunternehmen diese Vereinbarung kündigen, wenn der Kunde
    eine wesentliche Bestimmung dieser Vereinbarung verletzt und diese Verletzung der Vereinbarung
    nicht innerhalb von dreißig (30) Tagen nach dem Erhalt einer schriftlichen Mitteilung über die
    Verletzung behebt; eine derartige schriftliche Mitteilung kann per E-Mail oder durch eine andere
  elektronische Mitteilung erfolgen.</li>
  <li> Falls diese Vereinbarung gekündigt wird, sollen die Rechte, die dem Kunden, dem
    Administrator/den Administratoren und den Endbenutzern gewährt wurden, sofort eingestellt
    werden, mit der Ausnahme, dass das Kundenkonto sowie die Kundendaten eines Kundenkontos nach dem
    effektiven Enddatum des Abonnements fünfzehn (15) Tage lang zugänglich sein werden. Wenn diese
    Vereinbarung aus irgendeinem Grund abläuft oder gekündigt wird, außer wie es ausdrücklich in
    diesem Abschnitt genehmigt wurde, stimmt der Kunde zu, den Zugriff auf die Services und ihre
    Nutzung unverzüglich zu beenden. Der Kunde nimmt zur Kenntnis und ist damit einverstanden, dass
    Sharp und/oder Drittanbieter von Services keiner Verpflichtung unterliegen, Kundendaten nach dem
    hier festgelegten Zeitraum von dreißig (30) Tagen zu speichern, und dass alle Kundendaten nach
    dem Ablauf dieses Zeitraums von dreißig (30) Tagen unwiederbringlich gelöscht werden können.
  </li>
  <li> Unbeschadet jeder Kündigung oder jedem Ablauf dieser Vereinbarung soll der Kunde weiterhin für
    alle Gebühren verantwortlich bleiben, die vor dem Datum des Inkrafttretens der Kündigung oder
    des Ablaufs dieses Abkommens gemäß Ihrer Vereinbarung mit Ihrem Händler an den Händler bezahlt
    werden müssen oder die anderweitig für eine beliebige Nutzung der Services oder einen beliebigen
  Zugriff auf die Services an den Händler fällig sind.</li>
  <li> Mitteilungen an den Kunden gemäß diesem Abschnitt können per E-Mail oder durch eine andere
    elektronische Benachrichtigung erfolgen und an den Administrator/die Administratoren gerichtet
  werden.</li>
  <li> Folgende Abschnitte dieses Abkommens sollen auch nach dem Ablauf oder der Kündigung dieser
    Vereinbarung, aus welchem Grund auch immer, gelten: Anschnitte F(6), H, I, J(6) bis J(9), K, L,
  M, Q und S.</li>
  <li>Punkt 1 bis 9 dieses Artikels J (Laufzeit und Kündigung) gelten nicht für Synappx Manage.
    Synappx Manage kann Ihre
    kostenlose Nutzung jederzeit und aus beliebigem Grund nach alleinigem Ermessen von Sharp ohne
    Haftung Ihnen gegenüber
  beenden.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Schadenersatz</b></div>
  <div class="eula_point_left">Der Kunde wird Sharp, seine Händler, Drittanbieter von Services und alle
    damit verbundenen Geschäftspartner entschädigen, verteidigen und schadlos halten, einschließlich,
    aber nicht beschränkt auf Muttergesellschaften oder Tochtergesellschaften, Direktoren, Beauftragte,
    Angestellte, Agenten und Auftragnehmer (zusammen „Sharp-Parteien“), von und gegen alle
    Verbindlichkeiten, Schäden und Kosten (einschließlich Abrechnungskosten und angemessene
    Anwaltskosten), was sich aus einem Anspruch Dritter ergibt, bezüglich: (a) der Nutzung der Services
    durch den Kunden; (b) aller Kundendaten; (c) jeder Verletzung dieser oder jedem Verstoß gegen diese
    Vereinbarung durch den Kunden, den Administrator/die Administratoren und/oder einen Endbenutzer; und
    (d) jeden Verstoß oder angeblichen Verstoß gegen anwendbare Gesetze, Regeln oder Vorschriften, die
    für den Kunden, Administrator und/oder einen Endbenutzer hinsichtlich der Services gelten. Sharp
    wird wirtschaftlich angemessene Schritte unternehmen, um den Kunden über eine derartige Forderung
  oder ein derartiges Interesse gemäß diesem Abschnitt zu informieren.</div>
</div>

<div class="eula_point">
  <div><b>L. Haftungsbegrenzung</b></div>
  <div class="eula_point_left">IM VOLLEN GESETZLICH ZULÄSSIGEN UMFANG SIND DIE SHARP-PARTEIEN IN KEINEM
    FALL DEM KUNDEN, DEM ADMINISTRATOR/DEN ADMINISTRATOREN, ENDBENUTZERN ODER IRGENDEINER ANDEREN PARTEI
    GEGENÜBER HAFTBAR FÜR IRGENDWELCHE DIREKTEN, INDIREKTEN, ZUFÄLLIGEN, BESONDEREN ODER FOLGESCHÄDEN,
    EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF EINEN VERLUST VON GEWINNEN, DATEN, NUTZUNG ODER INHALTEN
    ODER ANDERWEITIGER VERLUSTE, DIE SICH AUS ODER IM ZUSAMMENHANG MIT DIESER VEREINBARUNG, DEN
    ZUSÄTZLICHEN BESTIMMUNGEN, DEN SERVICES, DEM KUNDENKONTO ODER KUNDENDATEN ERGEBEN. DIESER PARAGRAPH
    SOLL GÜLTIGKEIT BESITZEN, EGAL OB DIE HAFTUNGSTHEORIE AUF VERTRAG, UNERLAUBTER HANDLUNG,
    FAHRLÄSSIGKEIT, GARANTIEVERLETZUNG, GEFÄHRDUNGSHAFTUNG ODER ANDERWEITIG BASIERT, UND EGAL OB DIE
    SHARP-PARTEIEN AUF DIE MÖGLICHKEIT SOLCHER SCHÄDEN HINGEWIESEN WORDEN SIND. IN KEINEM FALL SOLL DIE
    GESAMTHAFTUNG DER SHARP-PARTEIEN GEGENÜBER DEM KUNDEN ODER EINEM DRITTEN DEN BETRAG ÜBERSTEIGEN, DER
    DREI MONATEN IHRER SERVICEGEBÜHR ENTSPRICHT. SIE STELLEN DIE SHARP-PARTEIEN HIERMIT VON ALLEN
    VERPFLICHTUNGEN, HAFTUNGEN UND ANSPRÜCHEN FREI, DIE DIESE BESCHRÄNKUNG ÜBERSTEIGEN. DIESE
    HAFTUNGSBEGRENZUNG ÜBERDAUERT DEN ABLAUF ODER DIE KÜNDIGUNG DIESER VEREINBARUNG AUS BELIEBIGEM GRUND
    UND GILT SELBST DANN, WENN SICH HERAUSSTELLT, DASS EIN IN DIESEM ABSCHNITT ANGEGEBENES BESCHRÄNKTES
  RECHTSMITTEL SEINEN WESENTLICHEN ZWECK VERFEHLT HAT.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Geltendes Recht/Verzicht auf Geschworenengericht</b></div>
  <div class="eula_point_left">Wenn der Kunde die Services nur für persönliche, nicht-geschäftliche Zwecke
    nutzt, unterliegt diese Vereinbarung den
    Gesetzen des Landes, in welchem der Kunde die Lizenz für die Nutzung der Services gekauft oder
  erhalten hat.</div>
  <div class="eula_point_left">Wenn der Kunde kein solcher Verbraucher ist, unterliegt diese Vereinbarung
    folgendem materiellen Recht und ist nach
  diesem auszulegen:</div>
  <ol>
    <li>dem Recht des Staates New York, wenn eine Lizenz für die Nutzung der Services gekauft oder
      erhalten wurde, während der
    Kunde sich in den Vereinigten Staaten, Kanada oder Mexiko aufhält;</li>
    <li>dem Recht von England und Wales, wenn eine Lizenz für die Nutzung der Services gekauft oder
      erhalten wurde, während der
    Kunde sich in Großbritannien oder einem EWG-Land aufhält;</li>
    <li>dem Recht des Landes der Europäischen Union, in dem sich der Kunde befindet, wenn vom Kunden in
      diesem Land der
    Europäischen Union eine Lizenz für die Nutzung der Services gekauft oder erhalten wurde;</li>
    <li>Dem japanischen Recht, wenn eine Lizenz für die Nutzung der Services gekauft oder erhalten
      wurde, während sich der Kunde
    in einem nicht vorstehend beschriebenen Rechtssystem befindet;</li>
  </ol>
  <div class="eula_point_left">Den jeweils zuständigen Gerichten von:</div>
  <ol>
    <li>New York County, New York, wenn die Gesetze von New York gelten;</li>
    <li>England und Wales, wenn die Gesetze von England und Wales gelten;</li>
    <li>dem Land der Europäischen Union des Kunden, wenn die Gesetze der Europäischen Union gelten;</li>
    <li>dem Bezirksgericht Osaka in Japan, wenn die japanische Gesetzgebung gilt</li>
    Diese haben jeweils die nicht ausschließliche Zuständigkeit für alle Streitigkeiten, die sich
    aus der Vereinbarung
    ergeben.
  </ol>
  <div class="eula_point_left">
    Alle Ansprüche, die sich aus dieser Vereinbarung gegen Sharp-Parteien ergeben, müssen innerhalb
    eines (1) Jahres nach
    Eintritt des Klagegrundes geltend gemacht werden, oder diese Klage bzw. der Klageanspruch verjährt.
    Hiermit verzichten
    der Kunde und Sharp auf eine Schwurgerichtsverhandlung hinsichtlich jeglicher Streitfälle im
    Zusammenhang mit dieser
  Vereinbarung oder den Services.</div>
</div>

<div class="eula_point">
  <div><b>N. Markenzeichen</b></div>
  <div class="eula_point_left">Die Marken oder Dienstleistungsmarken „SHARP“, „Synappx“, „Synappx
    Meeting“, „Synappx Go“ oder beliebige andere zugehörige Produktnamen, Servicenamen oder Logos, die
    verwendet oder zitiert werden und/oder auf die in den Services oder durch die Services hingewiesen
    wird, sind Markenzeichen, eingetragene Warenzeichen oder Dienstleistungsmarken von Sharp und/oder
    seiner verbundenen Unternehmen. Alle anderen Namen von Produkten und Services, Logos und/oder
    Firmennamen, die auf oder durch die Services erscheinen, sind das Eigentum ihrer jeweiligen Inhaber
    und können als ihre Markenzeichen, eingetragene Warenzeichen, Dienstleistungsmarken und/oder
  Handelsnamen geschützt sein.</div>
</div>

<div class="eula_point">
  <div><b>O. Höhere Gewalt</b></div>
  <div class="eula_point_left">Die Sharp-Parteien, Drittanbieter von Services und der Kunde haften nicht
    für eine unzulängliche Erfüllung, soweit diese durch einen Zustand verursacht wurde, der außerhalb
    der angemessenen Kontrolle dieser Partei lag, einschließlich, aber nicht beschränkt auf
    Naturkatastrophen, Kriegshandlungen, Terrorismus oder Feindseligkeit, Unruhen, Regierungshandlungen,
    Arbeitsbedingungen oder Störungen oder Ausfälle von Elektrizität, Telekommunikation oder Internet.
    Sharp und der Kunde stimmen zu, angemessene Anstrengungen zu unternehmen, um die Auswirkungen eines
  Ereignisses höherer Gewalt abzuschwächen.</div>
</div>

<div class="eula_point">
  <div><b>P. Export</b></div>
  <div class="eula_point_left">Der Kunde stimmt zu, dass Ihre Nutzung der Services und alle Leistungen des
    Zugriffs auf die Services und der Nutzung der Services durch lokale (im Land der Nutzung der
    Services) Exportkontrollgesetze geregelt werden (inklusive technischer Daten), und der Kunde stimmt
    zu, sich an alle diese Ausfuhrgesetze und -vorschriften zu halten (einschließlich Regelungen
    bezüglich „vorgesehener Ausfuhr“ und „vorgesehener Wiederausfuhr“). Der Kunde stimmt zu, dass keine
    Daten, Informationen, Softwareprogramme und/oder Materialien, die sich aus den Services ergeben
    (oder ein direktes Produkt davon sind), exportiert werden, direkt oder indirekt, die gegen diese
    Gesetze verstoßen, oder dass sie für einen durch diese Gesetze verbotenen Zweck genutzt werden,
    einschließlich und ohne Einschränkung für die Verbreitung von nuklearen, chemischen oder
  biologischen Waffen oder die Entwicklung von Raketentechnologie.</div>
</div>

<div class="eula_point">
  <div><b>Q. Statistische Informationen</b></div>
  <div class="eula_point_left">Unbeschadet anders lautender Bestimmungen in dieser Vereinbarung und
    unbeschadet aller sonstigen Bestimmungen darf Sharp die Nutzung der Services durch den Kunden
    überwachen und die Kundendaten in aggregierter und anonymer Weise nutzen, Statistiken erstellen,
    Informationen bezüglich der Bereitstellung und des Betriebs der Services nutzen und analysieren und
    derartige Informationen öffentlich zugänglich machen („Aggregierte Daten“), vorausgesetzt, dass
    solche aggregierte Daten den Kunden nicht identifizieren und keine Kundendaten weitergeben. Sharp
  behält alle geistigen Eigentumsrechte an derartigen aggregierten Daten.</div>
</div>

<div class="eula_points"><b>R. Änderung von Begriffen</b>
<ol>
  <li> Sharp kann die Bestimmungen dieser Vereinbarung gelegentlich nach eigenem Ermessen überarbeiten
    oder ändern. Falls diese Bestimmungen überarbeitet oder geändert werden, hat der
    Administrator/haben die Administratoren die Pflicht, die überarbeiteten oder geänderten
    Bestimmungen bei der ersten Anmeldung nach dem Datum des Inkrafttretens einer solchen
    Überarbeitung oder Änderung zu akzeptieren. Die aktuelle Version dieser Vereinbarung wird auf
    der <a tabindex="-1" class="text_underline" [href]="termsUseUrl"
  target="_blank">Synappx-Support-Website</a> veröffentlicht und der Kunde ist dafür
  verantwortlich, die Website regelmäßig zu überprüfen. Sharp wird angemessene Anstrengungen
  unternehmen, um dreißig (30) Tage vor dem Datum des Inkrafttretens einer Änderung eine Nachricht
  darüber zu senden, aber einige Änderungen können innerhalb von weniger als dreißig (30) Tagen
wirksam werden.</li>
<li> Wenn der Kunde die Services nach dem Datum des Inkrafttretens der überarbeiteten oder
  geänderten Vereinbarung weiterhin nutzt, stimmt der Kunde zu, dass er, sein Administrator/seine
  Administratoren und seine Endbenutzer im Anschluss darauf an die neuen Bestimmungen gebunden
  sind. Falls der Kunde nicht mit den überarbeiteten Bestimmungen der Vereinbarung einverstanden
ist, kann er den Zugriff auf die Services und deren Nutzung einstellen.</li>
</ol>
</div>
<div class="eula_points"><b>S. Zusätzliche Bestimmungen</b>
<ol>
  <li> Der Kunde stimmt zu, dass zwischen Sharp und dem Kunden keine Partnerschaft, kein Joint Venture
  und keine Agenturbeziehung besteht.</li>
  <li> Sofern Sharp vom Kunden nicht ausdrücklich schriftlich anderweitig in Kenntnis gesetzt wurde,
    kann Sharp den Namen des Kunden in eine Kundenliste der Marketingmaterialien von Sharp aufnehmen
  – inklusive Websites.</li>
  <li> Sofern in dieser Vereinbarung nichts anderes festgelegt ist, sollen allgemeine Mitteilungen von
    Sharp an den Kunden oder an die Endbenutzer hinsichtlich dieser Vereinbarung oder den Services
    auf der <a tabindex="-1" class="text_underline" [href]="supportType"
  target="_blank">Synappx-Support-Website</a>. veröffentlicht werden. Kunde und Endbenutzer
  sollen die <a tabindex="-1" class="text_underline" [href]="supportType"
target="_blank">Synappx-Support-Website</a> daher regelmäßig besuchen, um sich über
derartige Hinweise zu informieren. Spezifische Mitteilungen bezüglich der Services werden
protokollarisch an die E-Mail-Adresse des Administrators gesendet. Sämtliche Mitteilungen,
inklusive rechtliche Hinweise, Fragen oder Kommentare im Zusammenhang mit dieser Vereinbarung
sind zu richten an: <br>
<span>Synappx Product Manager</span>
<div>Sharp Corporation </div>
<div>492 Minosho-cho, Yamato-Koriyama City, </div>
<div>Nara 639-1186, Japan</div>
</li>
<li> Ohne die vorherige schriftliche Zustimmung von Sharp darf der Kunde keinen Teil dieser
  Vereinbarung abtreten oder übertragen. Sharp kann diese Vereinbarung abtreten, nachdem Sharp den
  Kunden in Form einer E-Mail, eines Beitrags oder einer Nachricht über die Services darüber
  informiert hat. Ungeachtet anders lautender Bestimmungen kann Sharp diesen Vertrag an ein
  verbundenes Unternehmen abtreten oder in Verbindung mit einer Fusion, Übernahme,
  Unternehmensneugestaltung oder dem Verkauf aller oder im Wesentlichen aller seiner
Vermögenswerte abtreten, ohne den Kunden darüber zu informieren.</li>
<li> Wenn Sharp auf die Geltendmachung eines Anspruchs im Rahmen einer Verletzung oder eines Rechts
  aus dieser Vereinbarung verzichtet, gilt nicht als Verzicht auf eine andere oder nachfolgende
Verletzung oder ein anderes oder nachfolgendes Recht.</li>
<li> Sollte eine der Bestimmungen dieser Vereinbarung (oder ein Teil davon) als nicht durchsetzbar
  oder rechtswidrig erwachtet werden, wird sie im geringsten erforderlichen Umfang geändert, damit
  sie durchsetzbar wird, und die restlichen Teile dieser Vereinbarung bleiben in vollem Umfang
rechtskräftig.</li>
<li> Diese Vereinbarung und die Zusätzlichen Bedingungen, falls vorhanden, bilden die gesamte
  Vereinbarung zwischen dem Kunden und Sharp hinsichtlich der Services und ersetzen alle
  vorherigen oder derzeit gültigen Übereinkünfte und Vereinbarungen, einschließlich aller
  Bestellungen/Aufträge, schriftlich oder mündlich, hinsichtlich des Gegenstands dieser
Vereinbarung.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
</div>
